/**
 * IMAGE-VIEWER.JS
 */

import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-video.css';

export default function InitImageViewer() {
	const lightGalleries = document.querySelectorAll('.media-viewer');
    if (lightGalleries.length === 0) return;

    if (window.lgInstances && window.lgInstances.length > 0) {
        window.lgInstances.forEach((gallery) => {
            gallery.destroy();
        });
    }

    setTimeout(function () {
        window.lgInstances = [];

        lightGalleries.forEach((gallery) => {
            let lg = lightGallery(gallery, {
                licenseKey: 'HJ7KN-STGR7-R8KGF-CU3W3',
                plugins: [lgVideo],
                selector: '.media-viewer-item',
                mobileSettings: {
                    showCloseIcon: true
                }
            });
            window.lgInstances.push(lg);
        });
    }, 50);
}